import {CanMatchFn} from '@angular/router';

const allowedFixtureStates = new Set(['base64-thumbnail']);
const allowedFixturePath = '/ai/assistants/fixture-base64';

export function isListingsVisualFixtureUrl(href: string): boolean {
  const url = new URL(href);
  const isLocalHost = ['localhost', '127.0.0.1', '[::1]', '::1'].includes(url.hostname);
  const fixtureState = url.searchParams.get('listingsVisualFixture') || '';

  return isLocalHost
    && url.pathname === allowedFixturePath
    && allowedFixtureStates.has(fixtureState);
}

export const listingsVisualFixtureCanMatch: CanMatchFn = () => {
  if (typeof window === 'undefined' || !window.location) {
    return false;
  }

  return isListingsVisualFixtureUrl(window.location.href);
};
